/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import PhotoAlbum from "react-photo-album";
import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import { useAuth } from "cms/auth/hooks/useAuth";
import { generateImageSlides } from "./utils";
import { isArrayNotEmpty, isValidGuid } from "cms/utils/empty-exists";
import "yet-another-react-lightbox/plugins/captions.css";

const ImageGalleryGrid = (props) => {

    const { token } = useAuth();
    const { image_gallery } = props || {};
    const [slides, setSlides] = useState([]);
    const [index, setIndex] = useState(-1);
    const showToggle = true;
    const descriptionTextAlign = "start";
    const descriptionMaxLines = 3;

    useEffect(() => {

        if (isArrayNotEmpty(image_gallery)) {

            const images = image_gallery.filter((element) => isValidGuid(element?.image));
            generateImageSlides(images, token)
                .then((result) =>
                    setSlides(result)
                );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [image_gallery]);

    const onClose = () => {
        setIndex(-1);
    };

    // https://react-photo-album.com/documentation#ClickHandler
    const onClickImage = (clickParams) => {
        const { index: current } = clickParams;
        setIndex(current);
    };

    return (
        <div className="simplicity-image-list-item">
            {isArrayNotEmpty(slides) && (
                <>
                    <PhotoAlbum
                        layout="rows"
                        photos={slides}
                        targetRowHeight={200}
                        onClick={onClickImage}
                    />
                    <Lightbox
                        plugins={[Captions, Fullscreen]}
                        index={index}
                        slides={slides}
                        captions={{ showToggle, descriptionTextAlign, descriptionMaxLines }}
                        open={index >= 0}
                        close={onClose}
                    />
                </>
            )}
        </div>
    );
};

export { ImageGalleryGrid };
